<template>
  <div class="trainee-scenario">

    <transition v-if="viewMode !== 'finished' && viewMode !== 'intro'" name="fade" mode="out-in">
      <div class="playlist-button">
        <!-- <h2 class="playlist-title" v-text="playlistData.name"></h2> -->
        <button class="btn" @click="playlistOverview = true"><i class="material-icons">playlist_play</i><span>View playlist</span></button>
      </div>
    </transition>

    <transition v-if="viewMode !== 'finished' && viewMode !== 'intro'" name="fade" mode="out-in">
      <div class="title">
        <h2 class="playlist-title" v-text="playlistData.name"></h2>
        <p v-if="viewMode === 'media'"
          v-text="playlistData.quickEvent
          ? 'This playlist consists of videos after which you are being asked to answer a few multiple-choice questions. The playlist ends with short learning outcomes.'
          : 'View injects before moving to decisions.'"></p>
      </div>
    </transition>

    <transition v-if="viewMode === 'intro'" name="fade" mode="out-in">
      <ScenarioIntro @done="viewMode = 'media'" @overview="playlistOverview = true" />
    </transition>

    <transition v-if="viewMode === 'plenary'"  name="fade" mode="out-in">
      <plenary-cover @done="viewMode = 'media'" />        
    </transition>
    
    <transition name="fade" mode="out-in">
      <div class="main-tabs" v-if="viewMode === 'decision' || viewMode === 'media'" >
        <button 
          v-for="(tab, index) in tabsToShow" 
          :key="index" 
          @click="mainTab = tab.component" 
          :class="{active: mainTab === tab.component}"
          class="rounded">
          <!-- <i v-if="tab.icon" class="material-icons" v-text="tab.icon"></i> -->
          <span class="icon" v-html="tab.icon"></span>
          <span class="title" v-text="tab.title"></span>
        </button>
      </div>
    </transition>

    <transition v-if="viewMode === 'decision' || viewMode === 'media'"  name="fade" mode="out-in">
      <!-- <plenary-cover @done="viewMode = 'media'" /> -->
      <main class="shadowed white rounded">
        <PieTimer v-if="currentItem" :current="currentItem" />

        <transition name="fade" mode="out-in">
          <component :is="mainTab" @done="setViewmode" @current="setCurrentItem"></component>
        </transition>
        <transition v-if="viewMode === 'media'" name="fade" mode="out-in">
          <ScenarioInjectsPanel @done="openDecision" />
        </transition>
      </main>
    </transition>

    <transition v-if="viewMode === 'outcomes'"  name="fade" mode="out-in">
      <!-- <plenary-cover @done="viewMode = 'media'" /> -->
      <main class="shadowed white rounded">
        <transition name="fade" mode="out-in">
          <LearningOutcomes @continue="nextStep" @current="setCurrentItem" />
        </transition>
      </main>
    </transition>

    <transition v-if="viewMode === 'done'" name="slide-to-left" mode="out-in">
      <ScenarioFinished :nextScenario="nextScenario" />
    </transition>

    <transition name="side-toggle" mode="out-in">
      <PlaylistOverview 
        v-if="playlistOverview" 
        @close="playlistOverview = false"
        :current-item="currentItem"
      />
    </transition>
  </div>
</template>

<script>
import Decision from "@/components/trainee/Decision.vue";
// import ScenarioHeader from "@/components/trainee/ScenarioHeader.vue";
import TimelineContainer from '@/components/TimelineContainer.vue';
import PieTimer from '@/components/PieTimer.vue';
import PlaylistOverview from '@/components/PlaylistOverview.vue';
import questionHelper from '@/components/trainee/QuestionHelper.vue';
import ModeratorPreparing from '@/components/trainee/ModeratorPreparing.vue';
import ScenarioIntro from '@/components/trainee/ScenarioIntro.vue';
import Facts from '@/components/trainee/Facts.vue';
import Maps from '@/components/trainee/Maps.vue';
import Injects from '@/components/trainee/Injects.vue';
import LearningOutcomes from '@/components/trainee/LearningOutcomes.vue';
import ScenarioTimeIndicator from '@/components/trainee/ScenarioTimeIndicator.vue';
import ScenarioInjectsPanel from '@/components/trainee/ScenarioInjectsPanel.vue';
import ScenarioFinished from '@/components/trainee/ScenarioFinished.vue';
import PlenaryCover from '@/components/trainee/PlenaryCover.vue';
import { scenarioMixin } from '@/mixins/scenarioMixin.js'


export default {
  name: "Scenario",
  mixins: [scenarioMixin],
  components: {
    'question-helper': questionHelper,
    'moderator-preparing': ModeratorPreparing,
    'plenary-cover': PlenaryCover,
    TimelineContainer,
    ScenarioIntro,
    Decision,
    Facts,
    Maps,
    Injects,
    LearningOutcomes,
    ScenarioTimeIndicator,
    ScenarioInjectsPanel,
    ScenarioFinished,
    PieTimer,
    PlaylistOverview
  },
  data() {
    return {
      // itemIndex: 0,
      // currentAnswer: "",
      currentItem: null,
      viewMode: "media",
      changeModeTo: "media",
      // responses: new Map(),
      sideTab: "Facts",
      mainTab: "Injects",
      tabAnimation: 'slide-to-right',
      questionAnimation: 'slide-to-left',
      playlistOverview: false,
      tabs: [
        // { title: "Decision", component: "Decision", icon: "search" },
        // { title: "Injects", component: "Injects", icon: "play_circle_filled" },
        // { title: "Facts", component: "Facts", icon: "search" },
        // { title: "Maps", component: "Maps", icon: "map" },
        // { title: "Resources" }
      ]
    }
  },
  created () {
    this.$store.dispatch('traineeStatusModule/setSid', this.scenarioId)
    this.$store.dispatch('traineeStatusModule/setPid', this.playlistId)
    
    // if ( ! this.$router.query.d ) {
    //   this.$store.dispatch('traineeStatusModule/setDecisionIndex', 0)
    // } 
    // this.setCurrentAnswer(0)

    this.viewMode = this.starterViewMode()

    if ( this.playlistData.items ) {
      this.tabs.push({ title: "Decision", component: "Decision", icon: `<img src="${require('@/assets/awesome-chess-knight.svg')}" />` })
    }
    if ( this.playlistData.injects ) {
      this.tabs.push({ title: "Injects", component: "Injects", icon: '<i class="material-icons">play_circle_filled</i>' })
    }
    if ( this.playlistData.facts || this.scenarioData.description ) {
      this.tabs.push({ title: "Facts", component: "Facts", icon: `<i class="material-icons">menu_book</i>` })
    }
    if ( this.playlistData.maps ) {
      this.tabs.push({ title: "Maps", component: "Maps", icon: '<i class="material-icons">map</i>' })
    }
  },
  methods: {
    starterViewMode () {
      let changeModeTo = ( this.playlistData.injects.length > 0 ? "media" : "decision")

      if ( this.$route.query.skipintro == 1 ) {
        this.$store.dispatch('traineeStatusModule/setViewedIntro', true)
      }

      if ( this.scenarioData.plenary && ! this.$store.state.scanned ) {
        return "plenary"
      } else if ( this.$route.query.outcomes ) {
        return "outcomes"
      } else if ( this.$route.query.d ) {
        this.mainTab = "Decision"
        return "decision"
      } else if (! this.$store.state.traineeStatusModule.viewedIntro ) {
        return "intro"
      } else {
        return changeModeTo
      }
    },
    setViewmode (mode) {
      this.viewMode = mode
    },
    setCurrentItem (item) {
      this.currentItem = item
    },
    getInjectData (id) {
      return this.$store.getters["scenarioModule/getInject"](id);
    },
    openModal (playlist) {
      this.$store.dispatch('modalModule/setActive', this.getInjectData(playlist[0]) )
      this.$store.dispatch('modalModule/setMediaPlaylist', playlist )
    },
    openDecision () {
      if ( this.playlistData.items.length > 0 ) {
        this.viewMode = 'decision'
        this.mainTab = 'Decision'
      } else if (this.nextPlaylist) {
        this.$router.push(`/trainee/scenario/${this.scenarioId}/playlist/${this.nextPlaylist.id}`)
      }
    },
    nextStep () {

        let index = this.scenarioData.playlists.findIndex( (el) => el == this.playlistId)
        let nextPl = this.scenarioData.playlists[++index]
        if ( nextPl ) {
          this.$store.dispatch('traineeStatusModule/finishPlaylist')
          this.$router.push({ path: '/trainee/scenario/'+this.scenarioId+'/playlist/'+ nextPl })
        } else {

          const notification = {
            type: 'success',
            message: 'Scenario complete.'
          }
          this.$store.dispatch('notification/add', notification, { root: true })
          this.viewMode = "done"
        }
    }
  },
  computed: {
    hasTabs () {
      return (this.playlistData.facts || this.playlistData.maps)
    },
    tabsToShow () {
      if ( this.viewMode !== 'decision') {
        return this.tabs.filter(tab => {
          return tab.component !== 'Decision'
        })

      } else {
        return this.tabs
      }
    },
    prevPlaylist () {
      let index = this.scenarioData.playlists.findIndex( (el) => el == this.playlistId)
      let pid = this.scenarioData.playlists[--index]
      return this.$store.getters["scenarioModule/getPlaylist"](pid);
    },
    nextPlaylist () {
      let index = this.scenarioData.playlists.findIndex( (el) => el == this.playlistId)
      let pid = this.scenarioData.playlists[++index]
      return this.$store.getters["scenarioModule/getPlaylist"](pid);
    },
    nextScenario () {
      return this.$store.getters["scenarioModule/getScenario"](this.scenarioData.nextScenario);
    }
  },
  watch: {
    scenarioId (val) {
      this.$store.dispatch('traineeStatusModule/setSid', val)
    },
    playlistId (val) {
      this.$store.dispatch('traineeStatusModule/setPid', val)
    },
    sideTab (val, oldVal) {
      const toPos = this.tabs.map(e => e.title).indexOf(val);
      const fromPos = this.tabs.map(e => e.title).indexOf(oldVal);
      if ( toPos > fromPos ) {
        this.tabAnimation = 'slide-to-left'
      } else {
        this.tabAnimation = 'slide-to-right'
      }
    }
  }
};
</script>

<style scoped lang="scss">
.trainee-scenario {
  max-width: var(--container-width);
  margin: 0 auto;
  display: grid;
  grid-gap: 24px;
  column-gap: 0;
  // row-gap: 0;
  grid-template-areas:
    ". playlist ."
    ". title ."
    ". tabs ."
    "smain smain smain"
    "pl-nav pl-nav pl-nav";
  grid-template-columns: 15px 1fr 15px;
  grid-template-rows: min-content min-content min-content minmax(300px, auto) min-content 50px;

  @media all and (min-width: 930px) {
    
    grid-template-areas:
      "playlist playlist"
      "title title"
      "tabs tabs"
      "smain smain";
    grid-template-columns: 1fr 1fr;
    grid-template-rows: min-content min-content min-content minmax(300px, auto) 150px;
  }
  // &.has-side {
  //   grid-template-areas:
  //   "timelines timelines"
  //   "saside smain"
  //   "saside sfooter";
  //   grid-template-columns: 1fr 2.5fr;
  // }

  .playlist-button {
    grid-area: playlist;
  }
  .title {
    grid-area: title;
    color: var(--primary);

    h2 {
      margin-bottom: 0.7em;
    }

    p {
      // font-weight: bold;
    }
  }

  .main-tabs {
    grid-area: tabs;
    position: relative;
    display: flex;
    
    height: 40px;
    margin-bottom: -24px; // Same as grid gap
    transition-delay: 0.4s;

    button {
      // flex: 1;
      display: flex;
      align-items: center;
      min-width: 140px;
      padding-left: 16px;
      margin-right: 12px;
      background-color: transparent;
      font-size: 16px;
      color: var(--primary);
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      background-color: #DFE5FC;
      // box-shadow: 0px -4px 6px 0px #00000029;
      box-shadow: inset 0px -15px 12px -12px #CCC;

      &:first-child {
        padding-left: 25px;
      }

      &:last-child {
        margin-right: 0;
      }
      
      .icon {
        margin-right: 7px;
      }

      
      @media all and (max-width: 767px) {
        min-width: 110px;        
      }

      @media all and (max-width: 540px) {
        min-width: 40px;

        &:first-child {
          padding-left: 10px;
        }
        .title {
          display: none;
        }
      }

      &.active {
        // background-color: #c9c9c9;
        background-color: #fff;
        z-index: 11;
        box-shadow: none;

        .title {
          display: block;
        }
      }
     
    }
  }
  main {
    position: relative;
    grid-area: smain;
    // background-color: #c9c9c9;
    display: flex;
    flex-direction: column;
    overflow: visible !important;
    // border-top-right-radius: 0;
    border-top-left-radius: 0;
    z-index: 10;

    & > div {
      background-color: #fff;
      z-index: 20;
    }
  }
  footer {
    grid-area: sfooter;
  }
  .plenary-panel {
    grid-area: smain;
  }

  .playlist-navigation {
    grid-area: pl-nav;
    display: flex;
    justify-content: flex-end;
  }
  .injects {
    grid-area: injects;
    margin-right: auto;
  }
  .prev-playlist {
    // margin-left: auto;
  }
  .next-playlist {
    margin-left: 15px;
  }

  .timeline-container {
    grid-area: timeline;
  }

  aside {
    grid-area: saside;
    // background-color: #c9c9c9;
    overflow: hidden;
    position: relative;
  }
}

.btnslide-fade-enter-active, .btnslide-fade-leave-active {
  transition: all 0.8s cubic-bezier(0.22, 0.61, 0.36, 1) 0s;
}
.btnslide-enter {
  width: 48px;
}
.btnslide-enter-to {
  width: 151px;
}
</style>